var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSubscription = function SvgSubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#33BB40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18c0 8.284 6.716 15 15 15 8.28-.009 14.991-6.72 15-15 0-8.284-6.716-15-15-15C9.716 3 3 9.716 3 18zm2.472-.005C5.47 11.073 11.078 5.458 18 5.451v.012c6.926 0 12.543 5.61 12.551 12.537-.005 6.922-5.62 12.531-12.542 12.53-6.922-.001-12.534-5.612-12.537-12.535z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.548 11.25a2.802 2.802 0 01-2.79 2.802h-7.293a2.428 2.428 0 00-2.424 2.416.182.182 0 01-.182.18.18.18 0 01-.18-.18v-2.61a2.802 2.802 0 012.802-2.801h9.887a.18.18 0 01.18.194z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.288 15.969h-7.823a2.801 2.801 0 00-2.802 2.79v2.61c0 .1.08.18.18.18.1 0 .18-.08.182-.18a2.428 2.428 0 012.428-2.428h5.227a2.801 2.801 0 002.802-2.79.182.182 0 00-.194-.182z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.212 20.87h-5.747a2.802 2.802 0 00-2.802 2.8v2.597a.18.18 0 00.18.182c.1 0 .182-.082.182-.182a2.428 2.428 0 012.428-2.426h3.15a2.802 2.802 0 002.8-2.801.182.182 0 00-.19-.17z",
    fill: "#fff"
  })));
};

export default SvgSubscription;